import { Analytics } from '@analytics';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useIsFeatureForCompanyEnabled } from '@utils/hooks';
import React from 'react';
import { useIntl } from 'react-intl';
import FlagIcon from '@assets/images/tip_direct/Flag.svg';
import LightningIcon from '@assets/images/tip_direct/LightningBolt.png';
import ProPlanModal from '../ProPlanModal';
import messages from './messages';

const useStyles = makeStyles({
  upgradeButton: {
    height: '53px',
    backgroundColor: '#ffffff',
    width: '237px',
    margin: '11px 12px',
    borderRadius: '13px',
    borderStyle: 'solid',
    borderWidth: '1px',
    padding: '0',
    borderImageSource: 'linear-gradient(to bottom, #6366f1, #a855f7)',
    borderImageSlice: '1',
    backgroundImage:
      'linear-gradient(to bottom, #fff, #fff), linear-gradient(to bottom, #6366f1, #a855f7)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    color: '#1e293b',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    textTransform: 'none'
  },
  lightningIcon: {
    width: '24px',
    height: '24px',
    marginRight: '4px'
  }
});

const AccessControlledTableBody = ({ feature, title, description = '' }) => {
  const classes = useStyles();
  const intl = useIntl();
  const [isOpenModal, setIsOpenModal] = React.useState(false);
  const isFeatureForCompanyEnabled = useIsFeatureForCompanyEnabled();
  const isFeatureEnabled = React.useMemo(() => isFeatureForCompanyEnabled(feature), [
    feature,
    isFeatureForCompanyEnabled
  ]);

  const handleUpgradeClick = () => {
    Analytics.track('Pro Plan Modal Opened via AccessControlledTableBody', {
      feature
    });
    setIsOpenModal(true);
  };

  return (
    <div className="flex flex-col justify-center items-center h-full p-[72px] gap-4">
      <img src={FlagIcon} alt="Flag" />
      <div className="flex flex-col items-center text-center max-w-[200px]">
        <span className="text-base font-bold text-slate-800">{title}</span>
        {description && (
          <span className="text-sm font-semibold text-slate-500">{description}</span>
        )}
      </div>
      {!isFeatureEnabled && (
        <Button className={classes.upgradeButton} onClick={handleUpgradeClick}>
          <img src={LightningIcon} alt="Lightning" className={classes.lightningIcon} />
          <span>{intl.formatMessage(messages.upgradeButton)}</span>
        </Button>
      )}

      <ProPlanModal isOpen={isOpenModal} onClose={() => setIsOpenModal(false)} />
    </div>
  );
};

export default AccessControlledTableBody;
